import filter from "lodash/fp/filter";
import flatMap from "lodash/fp/flatMap";
import flow from "lodash/fp/flow";
import getOr from "lodash/fp/getOr";
import forEach from "lodash/fp/forEach";

export default function updateFormDataFromRecipeData(recipeData) {
  return (formData) => {
    flow(
      getOr([], "products"),
      flatMap(getOr([], "customisations")),
      flatMap(getOr([], "fields")),
      filter(({ name }) => name === "Holder Length"),
      forEach((holderLengthField) => {
        if (
          !holderLengthField.options.find(
            ({ value }) => value === recipeData["Holder Length"]
          )
        ) {
          holderLengthField.options = [
            {
              value: recipeData["Holder Length"],
              label: recipeData["Holder Length"],
            },
          ];
        }
      })
    )(formData);

    return formData;
  };
}
